import {commonPromise} from '../../http'
import {
    ORDER_LIST,
    GET_APPELL_LIST_URL,
    GET_COURSE_LIST_URL,
    QUESTION_RECORD,
    GET_SHARE_IMG_URL,
    GET_MY_WALLET,
    MY_APPLY_HISTORY,
    ADD_APPLY_HISTORY,
    QUERY_USER_MUSEUM
} from '../global'

export const getOrderListFetch = (data) => commonPromise(data, ORDER_LIST);// 获取我的订单
export const getCourseListFetch = (data) => commonPromise(data, GET_COURSE_LIST_URL);// 获取我的课程
export const getAppellListFetch = (data) => commonPromise(data, GET_APPELL_LIST_URL);// 获取我的勋章
export const getQuestionRecordFetch = (data) => commonPromise(data, QUESTION_RECORD);// 分享称号信息
export const getShareImgFetch = (data) => commonPromise(data, GET_SHARE_IMG_URL);// 获取分享配图

export const getMyWallet = (data) => commonPromise(data, GET_MY_WALLET);// 获取我的钱包

export const getMyApplyHistory = (data) => commonPromise(data, MY_APPLY_HISTORY);// 获取我的提现历史
export const addApplyCashWithdrawal = (data) => commonPromise(data, ADD_APPLY_HISTORY);// 申请提现

export const userMuseum = (data) => commonPromise(data, QUERY_USER_MUSEUM)// 我的导览






// WEBPACK FOOTER //
// ./src/api/apiModules/aboutApi.js